import { Tag } from './interfaces';

const onlyUnique = (
  value: string | number,
  index: number,
  array: Array<string | number>
) => {
  return array.indexOf(value) === index;
};

export const isNewTag = (option: string | Tag | number): boolean => {
  return typeof option === 'string';
};

export const getUniqueSelectedTagsValue = (
  selectedOptions: Array<string | number | Tag>,
  existingTags: Tag[]
) => {
  let options: Array<string | number> = [];
  const foundExisingTags: Tag[] = [];

  selectedOptions.forEach((option) => {
    if (isNewTag(option)) {
      return options.push(
        ...(option as string)
          .split(',')
          .filter((option) => option.trim() !== '')
      );
    }

    options.push((option as Tag).id);
  });

  // filter out the tags that already exists.
  options = options.filter((option) => {
    if (!isNewTag(option)) {
      return true;
    }

    const foundExisingTag = existingTags?.find((tag) => tag.name === option);

    if (foundExisingTag) {
      foundExisingTags.push(foundExisingTag);
    }

    return !foundExisingTag;
  });

  // add the existing tags that where typed as string
  options.push(...foundExisingTags.map((tag) => tag.id));

  return options.filter(onlyUnique);
};
